const WISHLIST_KEY = "harenna_wishlist";

function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  } catch {
    return [];
  }
}

function refreshWishlistButtons() {
  const saved = getWishlist();

  document.querySelectorAll(".harenna-wishlist").forEach(button => {
    const selected = saved.includes(button.dataset.productHandle);
    button.setAttribute("aria-pressed", String(selected));
  });
}

document.addEventListener("click", event => {
  const button = event.target.closest(".harenna-wishlist");
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const handle = button.dataset.productHandle;
  if (!handle) return;

  const saved = getWishlist();
  const updated = saved.includes(handle)
    ? saved.filter(item => item !== handle)
    : [...saved, handle];

  localStorage.setItem(WISHLIST_KEY, JSON.stringify(updated));
  refreshWishlistButtons();
});

document.addEventListener("DOMContentLoaded", refreshWishlistButtons);